import { useLayoutEffect, useRef, useState } from 'react';
import type { SimpleShortenerProps } from './SimpleShortener';
import { SimpleShortener } from './SimpleShortener';

export type LineShortenerProps = Omit<
  SimpleShortenerProps,
  'shortenedHeight' | 'expandedHeight'
> & {
  shortenedLines: number;
  expandedLines?: number | null;
};

export function LineShortener({
  shortenedLines,
  expandedLines = null,
  ...forwardingProps
}: LineShortenerProps) {
  const [lineHeight, setLineHeight] = useState<number | null>(null);

  const innerRef = useRef<HTMLDivElement | null>(null);

  const shortenedHeight = lineHeight ? lineHeight * shortenedLines : 0;
  const expandedHeight =
    lineHeight && expandedLines !== null ? expandedLines * lineHeight : null;

  useLayoutEffect(() => {
    const innerElement = innerRef.current;

    if (!innerElement) {
      return;
    }

    const lineHeightPropertyValue =
      getComputedStyle(innerElement).getPropertyValue('line-height');

    setLineHeight(parseFloat(lineHeightPropertyValue));
  });

  return (
    <SimpleShortener
      {...forwardingProps}
      ref={innerRef}
      shortenedHeight={shortenedHeight}
      expandedHeight={expandedHeight}
    />
  );
}
